// react
import styled, { css } from 'styled-components';

// components
import { Button, Card, Logo, Title } from '@/components/atoms';

/**
 * CareReferralInfo renders the account settings page.
 */
export const CareReferralInfo = ({ onRefer }: CareReferralInfoProps) => {
  return (
    <CardWrapper>
      <StyledCard
        key='card-content'
        color='blue'
        isTransparent
        isBordered={false}
        isPaddingSm
      >
        <CardContent>
          <Logo size='md' />
          <Title isNoMargin>Care Simplified.</Title>
          <Description>
            Our care concierge service supports SJP clients and their families
            with professional advice on understanding, finding and funding care.
          </Description>
          <Description>Your client will benefit from:</Description>
          <StyledList>
            <li>
              1:1 <strong>unlimited access</strong> to a{' '}
              <strong>dedicated care expert</strong>
            </li>
            <li>
              Comprehensive digital <strong>care assessment</strong>
            </li>
            <li>
              <strong>Expert</strong> search for the{' '}
              <strong>best care options</strong>
            </li>
            <li>
              Direct access to <strong>vetted, regulated care providers</strong>
            </li>
            <li>
              <strong>Bespoke consultation</strong> on{' '}
              <strong>non-regulated funding benefits eligiblity</strong>
            </li>
            <li>
              <strong>Practical help</strong> applying for funding benefits
            </li>
          </StyledList>
        </CardContent>
        <Button ariaLabel={'refer-now'} onPress={onRefer} size='sm' isRectangle>
          Refer now
        </Button>
      </StyledCard>
    </CardWrapper>
  );
};

const StyledCard = styled(Card)`
  padding: ${(props) => props.theme.spacing[38]}
    ${(props) => props.theme.spacing[24]};
`;

const CardWrapper = styled.div`
  width: 100%;
  max-width: 100%;

  ${(props) =>
    props.theme.breakpoint.sm(css`
      max-width: 500px;
    `)}
  margin: 0;
  padding: 0;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[16]};
`;

const Description = styled.div`
  font: ${(props) => props.theme.typography.body.sm.regular};
  color: ${(props) => props.theme.color.neutral[100]};
`;

const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[4]};
  font: ${(props) => props.theme.typography.body.sm.regular};
  color: ${(props) => props.theme.color.neutral[100]};
  margin-top: 0;
  padding-top: 0;
`;

// types
interface CareReferralInfoProps {
  onRefer: () => void;
}

CareReferralInfo.displayName = 'CareReferralInfo';

export default CareReferralInfo;
